import { Link, useLocation } from 'react-router-dom'
import { useLocale } from '../../shared/i18n/LocaleContext'
import { findMenuItem } from '../../shared/navigation/menu'

export function PlaceholderPage() {
  const location = useLocation()
  const { t } = useLocale()
  const menuItem = findMenuItem(location.pathname)

  return (
    <main className="page-content">
      <section className="module-placeholder">
        <span className="placeholder-icon">{menuItem?.icon ?? '🧭'}</span>
        <span className="eyebrow">APL Enterprise</span>
        <h1>{menuItem ? t(menuItem.labelKey) : 'APL Enterprise'}</h1>
        <p>{t('placeholder.comingSoon')}</p>
        <Link to="/app/inicio" className="primary-button">
          ← {t('menu.home')}
        </Link>
      </section>
    </main>
  )
}
